import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highchart from "./Highchart";

import HighchartsConfig from '../../utils/HighchartsConfig';
import ReportDataMasseuse from "../utils/ReportDataMasseuse";
import DetailedReport from "../containers/DetailedReport";
import { withTheme } from '@material-ui/core';

//import {associationsData} from "../data/reports";

class DiscussionPostsReport extends Component {
	constructor(props, context) {
		super(props, context);

		let {theme, chartClasses, filter} = this.props;

		this.state = {
			chartConfig: HighchartsConfig.merge({
				chart: {
					className: chartClasses.chart
				},
				title: {
					align: "left",
					text: "Discussion Posts",
					style: {color: theme.palette.primary.darkGrey, fontSize: 14, fontWeight: 400}
				},
				accessibility: {
					point: {
						valueSuffix: " posts"
					},
					description: `The number of discussion posts per day over the last ${filter.previousDays} days.`
				},
				yAxis: {
					title: "",
					lineWidth: 0,
					gridLineWidth: 0,
					minRange : 0.1,
					allowDecimals: false,
					endOnTick: false,
					labels: {
						style: {
							fontSize: 14,
							color: theme.palette.primary.darkGrey,
							fontWeight: 400
						}
					}
				},
				xAxis: {
					type: "datetime",
					tickWidth: 0,
					offset: 20,
					labels: {
						y: 35,
						rotation: -45,
						align: "center",
						style: {
							fontSize: 14,
							color: theme.palette.primary.darkGrey,
							fontWeight: 400
						}
					},
					style: {
						//color: theme.palette.common.white
					}
				},
				plotOptions: {
					spline: {
						lineWidth: theme.spacing(1),
						softThreshold: false,
						marker: {
							radius: theme.spacing(1)
						}
					}
				},
				series: [{
					type: "spline",
					name: "Posts",
					color: theme.palette.secondary.green
				}]
			}, {
				modifyTickInterval: true,
				previousDays: filter.previousDays
			})
		};
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.data !== this.props.data) {
			let {chartConfig} = this.state,
				{data} = this.props;

			// TEMP
			//data = associationsData;

			if (data) {
				ReportDataMasseuse.convertDatesToMillis(data);
				chartConfig.series[0].data = ReportDataMasseuse.massageData(data, "period", "discussions");
				chartConfig.yAxis.labels.enabled = ReportDataMasseuse.getMaxValue(data, "discussions") !== 0;
			} else {
				chartConfig.series[0].data = null;
			}

			this.setState({chartConfig: chartConfig});
		}
	}

	render() {
		let {chartConfig} = this.state,
			{fidoError} = this.props;

		return (
			<DetailedReport
				fidoError={fidoError}
				ready={chartConfig.series[0].data && chartConfig.series[0].data.length > 0 ? true : false}>
				<Highchart
					darkTheme
					pngExport
					chartConfig={chartConfig} />
			</DetailedReport>
		);
	}
}

DiscussionPostsReport.propTypes = {
	theme: PropTypes.object.isRequired,
	chartClasses: PropTypes.object.isRequired,
	showSnackbar: PropTypes.func,
	location: PropTypes.object,
	filter: PropTypes.object,
	data: PropTypes.array,
	fidoError: PropTypes.bool
};

export default withTheme(DiscussionPostsReport);
